module.exports = __webpack_public_path__ + "img/book_dijia.8cef1591.png";